<div class="dropdown-container">
  <div
    class="togglable-header"
    (click)="toggle()"
    (keydown.space)="toggle()"
    (keydown.enter)="toggle()"
    tabindex="0"
  >
    <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': toggled ? 'rotate(180deg)' : '' }"></svg-icon>
    <div class="type">{{ ('modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.' + type + 'FeeHeader' ) | translate }}:</div>
    <div class="amount">{{ (amount ?? 0) * 100 | number:'1.0-2' }} %</div>
  </div>

  <div class="toggled-info" [ngClass]="{ 'toggled-info--visible': toggled }">
    <b>{{ ('modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.' + type + 'Fee' ) | translate }}</b>{{ ('modal.feeConfigs.opfFeeImpl.' + opfFeeImplVariant + '.' + type + 'FeeInfo' ) | translate }}
  </div>
</div>
